import React, { useEffect, useState } from "react";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { endpoint } from "../../common/constant";
import { fetchAllPostPromisedData } from "../../common/utils/methods/commonMethods/utilityMethod";
const ERROR_MGS =
  "At least one configuration value(s) of stream, CRCT, phase and date range, is missing. Please connect with corporate EDP team to create batch with the selected values";

const ErrorMessage = () => {
  return (
    <div className="d-flex text-danger gap-md">
      <div>
        <IoIosInformationCircleOutline size={25} />
      </div>
      <div>{ERROR_MGS}</div>
    </div>
  );
};
const AcademicPhaseValue = ({ courseId, academicGroup , setValues}) => {
  const [phase, setPhase] = useState("");
  const [isShowErrorMessage, setShowErrorMessage] = useState(false);

  useEffect(() => {
    const fetchPhase = async () => {
      const url = endpoint.getAcademicPhase;
      const response = await fetchAllPostPromisedData(url, {
        courseId,
        academicGroup,
      });
      if (response?.code === 200 && response.data && response.data.length > 0) {
        setPhase(response.data[0]);
        const academicPhase = response.data[0]
        setValues(prev=>({...prev,academicPhase  : [{ label:academicPhase?.phaseName, value:academicPhase?.id}], }))
      }else{
        
        if(response && response.data.length === 0){
            setShowErrorMessage(true);
            setValues(prev=>({...prev,academicPhase:[] }))
        }
      }
    };
    setShowErrorMessage(false);
    setPhase('')
    if (courseId && academicGroup) fetchPhase();
  }, [courseId, academicGroup]);
  if (isShowErrorMessage) return <ErrorMessage />;

  if (phase) return <div className="text-bold text-dark mt-2">{phase?.phaseName}</div>;
  return  <div className="mt-2">-</div>;
};

export default AcademicPhaseValue;
